// Cattle breeding-cycle API. Create/update/delete goes through SECDEF RPCs
// that mutate cattle_breeding_cycles and log cattle.breeding Activity in one
// transaction.

import type {RpcEnvelope, SupabaseClient} from './supabaseTypes.js';

// Every field is optional because the caller passes a partially-filled form
// object and each one is defaulted below — `cycle` itself is optional-chained,
// so the whole argument may be missing too.
export type CattleBreedingCycleInput = {
  id?: string | null;
  herd?: string | null;
  bull_exposure_start?: string | null;
  // Both tag fields are free-text, not arrays: migration 094 declares
  // p_bull_tags / p_cow_tags as `text` and stores NULLIF(<value>, '').
  bull_tags?: string | null;
  cow_tags?: string | null;
  notes?: string | null;
};

export async function upsertCattleBreedingCycle(
  sb: SupabaseClient,
  cycle?: CattleBreedingCycleInput | null,
): Promise<RpcEnvelope> {
  if (!sb) throw new Error('upsertCattleBreedingCycle: sb required');
  const {data, error} = await sb.rpc('upsert_cattle_breeding_cycle', {
    p_cycle_id: cycle?.id || null,
    p_herd: cycle?.herd || 'mommas',
    p_bull_exposure_start: cycle?.bull_exposure_start || null,
    p_bull_tags: cycle?.bull_tags || null,
    p_cow_tags: cycle?.cow_tags || null,
    p_notes: cycle?.notes || null,
  });
  if (error) throw new Error(`upsertCattleBreedingCycle: ${error.message || String(error)}`);
  return data;
}

export async function deleteCattleBreedingCycle(sb: SupabaseClient, cycleId: string): Promise<RpcEnvelope> {
  if (!sb) throw new Error('deleteCattleBreedingCycle: sb required');
  const {data, error} = await sb.rpc('delete_cattle_breeding_cycle', {
    p_cycle_id: cycleId,
  });
  if (error) throw new Error(`deleteCattleBreedingCycle: ${error.message || String(error)}`);
  return data;
}
